import { post, get, patch, remove } from "./setup";
import { getToken } from "../auth";

export const verifyUser = async (verificationToken) => {
  return await patch(`/users/verify?token=${verificationToken}`, null, null);
};

export const login = async (data) => {
  return await post('/users/login', data);
};

export const fetchUsers = async () => {
  const token = await getToken();
  return get('/users', token);
};

export const fetchDashboardData = async () => {
  const token = await getToken();
  return get('/dashboard', token);
};

export const fetchAccounts = async (type = null) => {
  const token = await getToken();
  return get('/accounts/?type='+type, token);
};

export const fetchUserAccounts = async (userId, type = null) => {
  const token = await getToken();
  return get(`/users/${userId}/accounts/?type=${type}`, token);
};

export const fetchUserTransactions = async (userId) => {
  const token = await getToken();
  return get(`/users/${userId}/transactions`, token);
};

export const fetchNotifications = async () => {
  const token = await getToken();
  return get('/notifications', token);
};

export const setNotificationReadStatus = async (notificationId) => {
  const token = await getToken();
  return patch(`/notifications/${notificationId}/markAsRead`, {}, token);
};

export const fetchFinlinkAccounts = async () => {
  const token = await getToken();
  return get('/accounts/finlink', token);
};

export const fetchAccountTransactions = async (id, page = 1) => {
  const token = await getToken();
  return get(`/accounts/${id}/transactions?currentPage=${page}`, token);
};

export const fetchDepositTransactions = async (page = 1) => {
  const token = await getToken();
  return get(`/transactions/all?type=investment&currentPage=${page}`, token);
};

export const fetchTransactionLogs = async (page = 1, typeFilter = "") => {
  const token = await getToken();
  let url = `/transactions/all?status=actedOn&currentPage=${page}`;
  if(typeFilter && typeFilter.length)
    url += `&type=${typeFilter}`;

  return get(url, token);
};

export const fetchWithdraws = async (page = 1) => {
  const token = await getToken();
  let url = `/transactions/all?type=withdraw&currentPage=${page}`;
  return get(url, token);
};

export const submitWithdrawApproval = async (transactionId, reference) => {
  const token = await getToken();
  let url = `/transactions/approveWithdraw/${transactionId}`;
  return patch(url, {reference}, token);
};

export const persistTransaction = async (data) => {
  const token = await getToken();
  return post('/accounts/recordTransaction', data, token);
};

export const setTransactionApproved = async (id) => {
  const token = await getToken();
  return patch(`/transactions/${id}/approve`, null, token);
};

export const setTransactionRejected = async (id, remark) => {
  const token = await getToken();
  return patch(`/transactions/${id}/reject`, {remark}, token);
};

export const fetchBankTransactions = async () => {
  const token = await getToken();
  return get('/bankTransactions', token);
};

export const persistBankTransaction = async (data) => {
  const token = await getToken();
  return post('/bankTransactions', data, token);
};

export const setBankTransactionApproved = async (id) => {
  const token = await getToken();
  return patch(`/bankTransactions/${id}/approve`, null, token);
};

export const setBankTransactionRejected = async (id, remark) => {
  const token = await getToken();
  return patch(`/bankTransactions/${id}/reject`, {remark}, token);
};

export const fetchBankBalances = async (page = 1) => {
  const token = await getToken();
  return get(`/mobileTransactions?currentPage=${page}`, token);
};

export const persistBankBalance = async (data) => {
  const token = await getToken();
  return post('/mobileTransactions', data, token);
};

export const setBankBalanceApproved = async (id) => {
  const token = await getToken();
  return patch(`/mobileTransactions/${id}/approve`, null, token);
};

export const setBankBalanceRejected = async (id, remark) => {
  const token = await getToken();
  return patch(`/mobileTransactions/${id}/reject`, {remark}, token);
};

export const fetchReconStatement = async ({month, year}) => {
  const token = await getToken();
  return get(`/transactions/reconciliationStatement?year=${year}&month=${month}`, token);
};

export const fetchSavingsData = async ({year, month, page = 1}) => {
  const token = await getToken();
  return get(`/transactions/savingsReport?year=${year}&month=${month}&currentPage=${page}`, token);
};

export const fetchStaffUsers = async () => {
  const token = await getToken();
  return get('/users/staff/', token);
};

export const persistStaffUser = async (data) => {
  const token = await getToken();
  return post('/users/staff/', data, token);
};

export const updateStaffUser = async (data) => {
  const token = await getToken();
  return patch(`/users/staff/${data._id}`, data, token);
};

export const restoreStaffUserPasswordToDefault = async (staffUserId) => {
  const token = await getToken();
  return patch(`/users/staff/${staffUserId}/resetPassword`, null, token);
};

export const markStaffUserAsApproved = async (staffUserId) => {
  const token = await getToken();
  return patch(`/users/staff/${staffUserId}/approve`, null, token);
};

export const changeStaffUserPassword = async (data) => {
  const token = await getToken();
  return post(`/users/staff/changePassword`, data, token);
};

export const deleteStaffUser = async (staffUserId) => {
  const token = await getToken();
  return remove(`/users/staff/${staffUserId}`, token);
};

export const fetchPermissions = async () => {
  const token = await getToken();
  return get('/access/permissions', token);
};

export const fetchRoles = async () => {
  const token = await getToken();
  return get('/access/roles', token);
};

export const persistRole = async (data) => {
  const token = await getToken();
  return post('/access/roles', data, token);
};

export const updateRoleDetails = async (data) => {
  const token = await getToken();
  return patch(`/access/roles/${data._id}`, data, token);
};

export const markRoleAsApproved = async (roleId) => {
  const token = await getToken();
  return patch(`/access/roles/${roleId}/approve`, null, token);
};

export const deleteRole = async (roleId) => {
  const token = await getToken();
  return remove(`/access/roles/${roleId}`, token);
};

export const fetchStaffUsersForRole = async (roleId) => {
  const token = await getToken();
  return get(`/access/roles/${roleId}/staff`, token);
};

export const updateRolePermissions = async (data) => {
  const token = await getToken();
  return patch('/access/grantPermission', data, token);
};

export const fetchAuditTrail = async (page = 1) => {
  const token = await getToken();
  return get(`/auditTrail?currentPage=${page}`, token);
};

export const fetchConfigs = async () => {
  const token = await getToken();
  return get(`/config`, token);
};

export const saveConfig = async (data) => {
  const token = await getToken();
  return post(`/config`, data, token);
};

export const fetchSupportedBanks = async (page = 1) => {
  const token = await getToken();
  return get(`/banks?currentPage=${page}`, token);
};

export const createSupportedBank = async (data) => {
  const token = await getToken();
  return post('/banks', data, token);
};

export const saveSupportedBank = async (data) => {
  const token = await getToken();
  return patch(`/banks/${data._id}`, data, token);
};

export const deleteSupportedBank = async (bankId) => {
  const token = await getToken();
  return remove(`/banks/${bankId}`, token);
};

export const fetchLoanApplicationsByStatus = async (type, page = 1) => {
  const token = await getToken();
  return get(`/loan/all?status=${type}&currentPage=${page}`, token);
};

export const fetchLoanApplications = async (page = 1) => {
  const token = await getToken();
  return get(`/loan/all?currentPage=${page}`, token);
};

export const createLoanApplication = async (data) => {
  const token = await getToken();
  return post('/loan', data, token);
};

export const saveLoanApplication = async (data) => {
  const token = await getToken();
  return patch(`/loan/${data._id}`, data, token);
};

export const markLoanApplicationAsBroadcasted = async (loanId, payload) => {
  const token = await getToken();
  return patch(`/loan/${loanId}/broadcast/`, payload, token);
};

export const markLoanApplicationAsDisbursed = async (loanId) => {
  const token = await getToken();
  return patch(`/loan/${loanId}/disburse`, null, token);
};

export const markLoanApplicationAsRejected = async (loanId) => {
  const token = await getToken();
  return patch(`/loan/${loanId}/reject`, null, token);
};

export const markLoanApplicationAsApproved = async (transactionId) => {
  const token = await getToken();
  return patch(`/loan/${transactionId}/approve`, null, token);
};

export const markLoanDisbursementAsRejected = async (transactionId, payload) => {
  const token = await getToken();
  return patch(`/loan/${transactionId}/rejectLoanDisbursement`, payload, token);
};

export const fetchReminders = async () => {
  const token = await getToken();
  return get('/schedule/', token);
};

export const deleteReminder = async (reminderId) => {
  const token = await getToken();
  return remove('/schedule/' + reminderId, token);
};

export const editReminder = async (payload) => {
  const token = await getToken();
  return patch('/schedule/' + payload._id, payload, token);
};

export const scheduleReminder = async (payload) => {
  const token = await getToken();
  return post('/schedule/', payload, token);
};